// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a095028a","247":"9a21d70d","453":"bc360b94","627":"c1a1c3fb","653":"088dc9e5","768":"acea47f5","834":"1a52512d","867":"c46729dc","923":"1abb1846","938":"90705d59"}[chunkId] + ".chunk.js";
};